import createReactComponent from '../createReactComponent';
export default createReactComponent('playlist-x', 'IconPlaylistX', [
  ['path', { d: 'M19 8h-14', key: 'svg-0' }],
  ['path', { d: 'M5 12h7', key: 'svg-1' }],
  ['path', { d: 'M12 16h-7', key: 'svg-2' }],
  ['path', { d: 'M16 14l4 4', key: 'svg-3' }],
  ['path', { d: 'M20 14l-4 4', key: 'svg-4' }],
]);
